import {Routes} from '@angular/router';
import {authGuard} from './guards/auth.guard';
import {TeamSelectionComponent} from './pages/team-selection/team-selection.component';
import {LogoutComponent} from './components/logout/logout.component';
import {InitializationComponent} from './components/initialization/initialization.component';
import {UserHal} from './models/HAL/user-hal.model';
import {TeamHal} from './models/HAL/team-hal.model';
import {DefaultPageResolver} from './resolvers/default.page.resolver';
import {CasesOverviewComponent} from './pages/cases-overview/cases-overview.component';
import {CasesOverviewResolver} from './resolvers/cases-overview.resolver';
import {LoginComponent} from './components/login/login.component';
import {LandingPageComponent} from './pages/landing-page/landing-page.component';
import {MemberOverviewComponent} from './pages/member-overview/member-overview.component';
import {CaseDetailComponent} from './pages/case-detail/case-detail.component';
import {CaseHal} from './models/HAL/case-hal.model';
import {MemberHal} from './models/HAL/member-hal.model';
import {DocumentPreviewComponent} from './pages/document-preview/document-preview.component';
import {DocumentHal} from './models/HAL/document-hal.model';
import {CaseCreationComponent} from './pages/case-creation/case-creation.component';
import {RequestInformationComponent} from './pages/request-information/request-information.component';
import {CaseRequestInformationHal} from './models/HAL/caseRequestInformation-hal.model';
import {environment} from '../environments/environment';
import {CaseCompletionComponent} from './pages/case-completion/case-completion.component';
import {SignatureProcessComponent} from './pages/start-signature-process/signature-process';
import {OnlineIdentificationComponent} from './pages/start-online-identification/online-identification';

export const routes: Routes = [
  {
    path: 'landing',
    component: LandingPageComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: environment.collaboratorBasePath.replace(/^\//, ''),
    loadChildren: () =>
      import('./collaborator/collaborator.routes').then(
        (m) => m.routes
      ),
  },
  {
    path: 'users/:userId',
    component: InitializationComponent,
    canActivate: [authGuard],
    resolve: {user: DefaultPageResolver<UserHal>}
  },
  {
    path: 'teams',
    component: TeamSelectionComponent,
    canActivate: [authGuard],
    resolve: {team: DefaultPageResolver<TeamHal>}
  },
  {
    path: 'teams/:teamId/cases',
    component: CasesOverviewComponent,
    canActivate: [authGuard],
    resolve: {cases: CasesOverviewResolver}
  },
  {
    path: 'teams/:teamId/cases/create',
    component: CaseCreationComponent,
    canActivate: [authGuard]
  },
  {
    path: 'teams/:teamId/cases/:caseId/requestInformation',
    component: RequestInformationComponent,
    canActivate: [authGuard],
    resolve: {requestInformation: DefaultPageResolver<CaseRequestInformationHal>}
  },
  {
    path: 'teams/:teamId/cases/:caseId/signatureProcess',
    component: SignatureProcessComponent,
    canActivate: [authGuard],
    resolve: {signatureProcess: DefaultPageResolver<CaseHal[]>}
  },
  {
    path: 'teams/:teamId/cases/:caseId/onlineIdentification',
    component: OnlineIdentificationComponent,
    canActivate: [authGuard],
    resolve: {onlineIdentification: DefaultPageResolver<CaseHal>}
  },
  {
    path: 'teams/:teamId/cases/:caseId/complete',
    component: CaseCompletionComponent,
    canActivate: [authGuard],
    resolve: {completeCase: DefaultPageResolver<CaseHal>}
  },
  {
    path: 'teams/:teamId/cases/:caseId',
    component: CaseDetailComponent,
    canActivate: [authGuard],
    resolve: {case: DefaultPageResolver<CaseHal>}
  },
  {
    path: 'teams/:teamId/cases/:caseId/documents/:documentId',
    component: DocumentPreviewComponent,
    canActivate: [authGuard],
    resolve: {document: DefaultPageResolver<DocumentHal>}
  },
  {
    component: MemberOverviewComponent,
    path: 'teams/:teamId/memberships',
    canActivate: [authGuard],
    resolve: {memberHal: DefaultPageResolver<MemberHal>}
  },
  {
    path: '**',
    redirectTo: 'landing'
  }
];
